// extracted by mini-css-extract-plugin
export default {"outer":"FeaturesCard_outer__jBCKk","iconTitleWrapper":"FeaturesCard_iconTitleWrapper__UfM55","icon":"FeaturesCard_icon__cAJKk","title":"FeaturesCard_title__WGZXI"};